const EMAIL =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const PHONE = /^\d{10}$/;

export const PASSWORD_MINIMUM = 6;

export const isEmail =
  (errorText = `Please enter correct email format`) =>
  (email) => {
    if (EMAIL.test(email)) return undefined;
    return errorText;
  };

export const isMobilePhoneNumber = (value) => {
  let phoneNumber = value ?? '';
  phoneNumber = phoneNumber.replace(/-/gi, '');
  return PHONE.test(phoneNumber);
};

export const MOBILE_PHONE_MASK = [
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];
